import type { Lang } from "@/i18n/translations";

export type LegalDocId = "privacy" | "cookies" | "terms";

export const LEGAL_PATHS: Record<LegalDocId, { sv: string; en: string }> = {
  privacy: { sv: "/integritetspolicy", en: "/en/privacy-policy" },
  /** Matches production URL on intygslakaren.se */
  cookies: { sv: "/cookie-policy", en: "/en/cookie-policy" },
  terms: { sv: "/anvandarvillkor", en: "/en/terms-of-use" },
};

export function legalPath(id: LegalDocId, lang: Lang): string {
  return LEGAL_PATHS[id][lang];
}
